import { OpenTelemetryInitializer } from "@/app/OpenTelemetryInitializer.tsx";
import { AppLoading } from "@/components/ui/app-loading/AppLoading.tsx";
import type { ColorScheme } from "@hopper-ui/components";
import { HopperProvider } from "@hopper-ui/components";
import { ToastContainer } from "@workleap-ai/shared";
import { Suspense, useState } from "react";
import { Outlet, useNavigate } from "react-router";

export const AppRoot = () => {
    const navigate = useNavigate();
    const [colorScheme] = useState<ColorScheme>("light");

    return (
        <HopperProvider theme="workleap" colorScheme={colorScheme} withBodyStyle navigate={navigate}>
            <ToastContainer />
            <OpenTelemetryInitializer />
            <Suspense fallback={<AppLoading />}>
                <Outlet />
            </Suspense>
        </HopperProvider>
    );
};
